import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'

//See https://vue-i18n.intlify.dev/guide/advanced/typescript.html#global-resource-schema-type-definition
const i18n = createI18n({
  locale: import.meta.env.VITE_FIRST_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FIRST_DEFAULT_LOCALE,
  legacy: false,
})

export default boot(async ({ app }) => {
  const fallbackLocale = i18n.global.fallbackLocale?.value
  if (fallbackLocale) {
    const path = fallbackLocale.replace('_', '-')
    try {
      const messages = await import(`../i18n/translations/${path}.json`)
      i18n.global.setLocaleMessage(fallbackLocale, messages.default)
    } catch (err) {
      console.error(`Could not load translations ${fallbackLocale}`)
    }
  }

  app.use(i18n)
})

export { i18n }
